export default __webpack_public_path__ + "static/media/Olim2.a87b7a7c.png";